import { NgModule } from '@angular/core';
import { RenderBlocksModule } from 'render/render-blocks/render-blocks.module';
import { AltTextPipe } from 'render/render-shared/alt-text/alt-text.pipe';
import { RenderSharedModule } from 'render/render-shared/render-shared.module';
import { LazyLoadModule } from 'shared/lazy-load/lazy-load.module';
import { SharedModule } from 'shared/shared.module';

import { DurationPipe } from 'extensions/st/piece-events/front/pipes/duration.pipe';
import { SafeDatePipe } from 'extensions/st/piece-events/front/pipes/safe-date.pipe';

import { PieceConcludedEventsRenderComponent } from './piece-concluded-events-render.component';


export const pieceConcludedEventsRenderModuleEntryComponents = [
  PieceConcludedEventsRenderComponent
];

@NgModule({
  imports: [
    LazyLoadModule,
    SharedModule,
    RenderSharedModule,
    RenderBlocksModule,
    AltTextPipe,
    SafeDatePipe,
    DurationPipe
  ],
  declarations: pieceConcludedEventsRenderModuleEntryComponents
})
export class PieceConcludedEventsRenderModule {}

export default pieceConcludedEventsRenderModuleEntryComponents;
